import { APIClient } from "../helpers/api_helper";
import { ApiResponse } from "../types/api";

const api = new APIClient();

export interface CalendarBoundsDay {
  date: string;
  closed: boolean;
  windows: Array<{
    start_time: string;
    end_time: string;
  }>;
  closure_reason?: string | null;
  closure_exception_id?: number | null;
}

export interface UnitCalendarBounds {
  slot_min_time: string;
  slot_max_time: string;
  scroll_time: string;
  days: CalendarBoundsDay[];
}

export interface CalendarBoundsQuery {
  start_date: string;
  end_date: string;
}

export const getUnitCalendarBounds = (
  unitId: number,
  query: CalendarBoundsQuery
): Promise<ApiResponse<UnitCalendarBounds>> =>
  api.get<ApiResponse<UnitCalendarBounds>>(`/units/${unitId}/calendar-bounds`, query);
